import { PlayingStates } from "../types/currentlyPlayingState";

export const PLAYING_POLL_MS = 3000;
export const IDLE_POLL_MS = 10000;
export const DEFAULT_RATE_LIMIT_MS = 30000;

export const getPlaybackPollDelay = (
  state: PlayingStates,
  isVisible: boolean,
  playingPollMs = PLAYING_POLL_MS
): number | null => {
  if (!isVisible) return null;
  return state === PlayingStates.Playing ? playingPollMs : IDLE_POLL_MS;
};

export const parseRetryAfterMs = (header: string | null, fallbackMs: number): number => {
  if (header === null) return DEFAULT_RATE_LIMIT_MS;
  const seconds = Number(header);
  return Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : fallbackMs;
};

export const createRequestGate = (request: () => Promise<void>): (() => Promise<void>) => {
  let active: Promise<void> | null = null;
  let followUpRequested = false;

  return () => {
    if (active) {
      followUpRequested = true;
      return active;
    }

    active = (async () => {
      do {
        followUpRequested = false;
        await request();
      } while (followUpRequested);
    })().finally(() => {
      active = null;
    });
    return active;
  };
};
